module.exports = __webpack_public_path__ + "static/media/trip-cost.6f497daf.svg";